<script lang="ts">
	//Design system components
	import { Input, Text } from '@Shelly/shelly-design-system';

	export let text,
		value,
		min,
		max,
		icon,
		step,
		callback,
		type,
		inputmode = '';
</script>

<Text element="h2" class="mb-s">
	{text}
</Text>

<Input
	size="m"
	bind:value
	max_width={'unset'}
	label="0"
	{inputmode}
	{icon}
	{type}
	{min}
	{max}
	{step}
	on:change={callback}
	id="input-8sm8f16"
	aria-labelledby="input-8sm8f16"
/>
